import React from 'react';
import { validation } from '../utility';

function Input({ type, className, error, name, label, placeholder, value, onChange, inline, autoComplete }) {
  if (!placeholder) {
    placeholder = label;
  }
  return (
    <div className={className + ' ' + (inline ? 'error-container-inline' : 'error-container')}>
      <label htmlFor={name} className="form-label">{label}</label>
      <input type={type} autoComplete={autoComplete} className={validation('form-control subscribe-desktop-input', error)} name={name} id={name} placeholder={placeholder} aria-label={label} value={value} onChange={onChange} />
      <p className="error">{error ? '(' + error + ')' : ''}&nbsp;</p>
    </div>
  );
}

export default Input;
